export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.homeStructure = payload;

  return newState;
};
